<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle">
    <v-chart
      v-if="showChart"
      id="chart"
      class="chart"
      :option="getOption"
      :init-options="getInitOptions"
      ref="gauge"
      theme="ovilia-green"
      autoresize
    />
  </div>
</template>

<script>
import { hasProperty } from "utils"
import parentMixin from "components/bigScreenComponents/base"
import plugins from "./plugin"
import handleChartData from "utils/updateData/chart/handleChartData.js"

export default {
  mixins: [parentMixin, plugins, handleChartData],
  name: "cxGauge",
  data() {
    return {
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      eventCallbackList: {
        click: [],
        dblclick: [],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      }
    }
  },
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      // this.axisLabel.rich
      if (this.options.chartOption?.yAxis?.axisLabel?.rich) {
        const barData = newVal.find(item => item.type === "bar")
        const keys = Object.keys(this.options.chartOption.yAxis.axisLabel.rich)
        if (barData.data.length !== keys.length - 2) {
          const rankKays = keys
            .filter(item => item !== "rank" && item.includes("rank"))
            .sort((a, b) => Number(a[a.length - 1]) - Number(b[b.length - 1]))
          const lastRank = rankKays[rankKays.length - 1]
          const newRank = JSON.parse(JSON.stringify(this.options.chartOption.yAxis.axisLabel.rich[lastRank]))
          console.log(this.ids)
          this.$changeOptionsEV(
            newRank,
            "chartOption.yAxis.axisLabel.rich.rank" + (Number(lastRank[lastRank.length - 1]) + 1),
            false
          )
        }
      }
      if (newVal.length !== oldVal.length) {
        this.$refs.bar.setOption(this.options.chartOption, true)
      } else if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        this.initOption = this.options.initOptions
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "bar")
    },
    isAutoPlayToolTip(newVal, oldVal) {
      this.autoplayTooltip()
    },
    autoPlayToolTipIntervalTime(newVal, oldVal) {
      if (this.isAutoPlayToolTip) {
        this.autoplayTooltip()
      }
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.gauge?.setOption(this.getOption)
      } else {
        this.$refs.gauge?.clear()
      }
    }
  },
  mounted() {
    this.refreshFunc()
    this.autoplayTooltip()
  },
  destroyed() {
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  },
  methods: {
    checkVal(opt, newVal, oldVal) {
      newVal.forEach((item, index) => {
        //如果当前echarts使用的数据没有在realvalue字符串的开头，则说明realvalue被改变了
        if (item.realValue.indexOf(item.value) !== 0) {
        }
      })
    },
    /*initugePlugin(opt) {
      const plugins = [...this.options.chartOption.pluginName].filter(it => it.trim().length)
      plugins.forEach(pluginName => {
        if (hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
          this[pluginName](opt)
        }
      })
    },*/
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.options.isAutoPlayToolTip) {
        return
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.bar?.chart
      let data = this.getOption.series[0].data
      this.autoPlayToolTipTimer = setInterval(() => {
        myChart._api.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.tooltipIndex
        })
        this.tooltipIndex++
        if (this.tooltipIndex > data.length - 1) {
          this.tooltipIndex = 0
        }
      }, this.options.autoPlayToolTipIntervalTime)
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
